import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-6',
  templateUrl: './cards-6.component.html'
})
export class Cards6Component {



    }
